import PublicLayout from '@/components/public/PublicLayout';
import CumpleEventosSection from '@/components/public/CumpleEventosSection';
import { Particles } from '@/components/public/Particles';

export default function CumpleanosEventosPage() {
    return (
        <PublicLayout>
            <section className="relative overflow-hidden bg-gradient-candy text-[hsl(var(--kche-dark))] py-16 sm:py-20">
                <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-white/40 blur-3xl" />
                <Particles count={12} />
                <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <p className="text-sm font-bold font-display text-[hsl(var(--kche-purple))] uppercase tracking-wider">Cumpleaños y eventos</p>
                    <h1 className="mt-1 text-4xl sm:text-5xl lg:text-6xl font-display font-bold leading-tight">Celebra <span className="text-[hsl(var(--kche-pink))]">a lo grande</span> en Kche</h1>
                    <p className="mt-4 max-w-2xl text-lg">Cumpleaños, salidas escolares, eventos corporativos y celebraciones. Cuéntanos tu idea y la coordinamos juntos.</p>
                </div>
            </section>
            <CumpleEventosSection withForm source="event_form" />
        </PublicLayout>
    );
}
